/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Scene_Change_Detection_Failed_ToastInputs */

const en_scene_change_detection_failed_toast = /** @type {(inputs: Scene_Change_Detection_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to detect shot changes. ${i?.error}`)
};

const fr_scene_change_detection_failed_toast = /** @type {(inputs: Scene_Change_Detection_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de la detection des changements de plan. ${i?.error}`)
};

const de_scene_change_detection_failed_toast = /** @type {(inputs: Scene_Change_Detection_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Schusswechsel konnten nicht erkannt werden. ${i?.error}`)
};

const it_scene_change_detection_failed_toast = /** @type {(inputs: Scene_Change_Detection_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile rilevare i cambi di tiro. ${i?.error}`)
};

const ru_scene_change_detection_failed_toast = /** @type {(inputs: Scene_Change_Detection_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось обнаружить изменения в выстреле. ${i?.error}`)
};

const es_scene_change_detection_failed_toast = /** @type {(inputs: Scene_Change_Detection_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudieron detectar cambios en la toma. ${i?.error}`)
};

const zh_cn2_scene_change_detection_failed_toast = /** @type {(inputs: Scene_Change_Detection_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`未能检测到投篮变化。${i?.error}`)
};

const ja_scene_change_detection_failed_toast = /** @type {(inputs: Scene_Change_Detection_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ショットの変更を検出できませんでした。${i?.error}`)
};

const hi_scene_change_detection_failed_toast = /** @type {(inputs: Scene_Change_Detection_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`शॉट में हुए बदलावों का पता लगाने में विफल। ${i?.error}`)
};

const pt_pt2_scene_change_detection_failed_toast = /** @type {(inputs: Scene_Change_Detection_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha na detecção de alterações de disparo. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to detect shot changes. {error}" |
*
* @param {Scene_Change_Detection_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_failed_toast = /** @type {((inputs: Scene_Change_Detection_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_change_detection_failed_toast(inputs)
	if (locale === "de") return de_scene_change_detection_failed_toast(inputs)
	if (locale === "it") return it_scene_change_detection_failed_toast(inputs)
	if (locale === "ru") return ru_scene_change_detection_failed_toast(inputs)
	if (locale === "es") return es_scene_change_detection_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_change_detection_failed_toast(inputs)
	if (locale === "ja") return ja_scene_change_detection_failed_toast(inputs)
	if (locale === "hi") return hi_scene_change_detection_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_change_detection_failed_toast(inputs)
	return en_scene_change_detection_failed_toast(inputs)
});